export default function CafeEspecialidadSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Imagen */}
          <div className="order-2 lg:order-1">
            <div className="w-full h-96 lg:h-[500px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/1c905122d7916b759598966417b2314b/25d87e549854182da7dbdb91a289bb76.jpeg"
                alt="Café de especialidad"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Texto */}
          <div className="order-1 lg:order-2 space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-stone-800">
              Nuestro Café
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed">
              Trabajamos con café de especialidad cuidadosamente seleccionado para entregar una experiencia única en cada taza.
            </p>
            <p className="text-base text-stone-600 leading-relaxed">
              Cada grano es tostado artesanalmente, respetando sus características naturales y resaltando los sabores que hacen especial a cada origen. Nuestro compromiso es ofrecerte el mejor café en el corazón de la Patagonia.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center gap-3 bg-amber-50 px-5 py-3 rounded-full">
                <i className="ri-checkbox-circle-line text-amber-700 text-xl"></i>
                <span className="text-stone-700 font-medium">Tostado Artesanal</span>
              </div>
              <div className="flex items-center gap-3 bg-amber-50 px-5 py-3 rounded-full">
                <i className="ri-checkbox-circle-line text-amber-700 text-xl"></i>
                <span className="text-stone-700 font-medium">Origen Selecto</span>
              </div>
              <div className="flex items-center gap-3 bg-amber-50 px-5 py-3 rounded-full">
                <i className="ri-checkbox-circle-line text-amber-700 text-xl"></i>
                <span className="text-stone-700 font-medium">Calidad Premium</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
